export default "__VITE_ASSET__B_M8RcBu__"